import { ISaveReportForm, yupLocalized } from "@ryde/shared";

export const saveReportValidationSchema: Partial<
  Record<keyof ISaveReportForm, any>
> = {
  name: yupLocalized.string().required(),
};
